import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const fireHydrant = defineConnector({
  identifier: "fireHydrant",
  name: "FireHydrant",
  tagLine: "Incident management platform",
  logo,
  protocol: "http",
  tags: ["observability"],
  defaultUrlPattern: () => "https://api\\.firehydrant\\.io/.*",
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Get an API token",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to [FireHydrant](https://app.firehydrant.io/) and navigate to **Settings > API Keys** to create an API key.",
        },
      ],
    },
    {
      title: "Enter your API token",
      items: [
        {
          kind: "input",
          label: "FireHydrant API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.firehydrant.io/v1/ping",
  },
});
